// Utility function to format tags as string for filtering
export function formatTagsRecordToString(
    tags: Record<string, string[]>
): string {
    return Object.entries(tags)
        .flatMap(([categoryName, tagNames]) =>
            tagNames.map((tagName) => `{${categoryName} - ${tagName}}`)
        )
        .join(", ");
}

export function dropUndefinedTags(tags: {
    [key: string]: string[] | undefined;
}): Record<string, string[]> {
    const result: Record<string, string[]> = {};
    for (const key in tags) {
        if (Array.isArray(tags[key])) {
            result[key] = tags[key]!;
        }
    }
    return result;
}
